
import styled from 'styled-components'

// import {Icon} from '../../components'

function OpenRouter() {
    return (
        <RBlock src="./gameUI/router.png" />
    )
}

export default OpenRouter

const RBlock = styled.img`
    padding: 0;
    display: block;
    margin-left: 8px;
    width: 36px;
`

